const enUSMessages = {
  enUS: {
    payment: {
      cards: {
        postcode: 'Zip Code',
      },
      autoRenew: '', // todo: intentionally blank as no A/R
      welcome: {
        renew:
          "The Missouri River Points Pass will launch fully on Thursday 23rd June. You will receive a confirmation email as well as account details to be able to book your golf on the 23rd June. In the meantime, don't forget to refer friends for an additional 10 points each", // todo: blank for US for now (no A/R)
      },
      checkoutTabs: {
        membership: 'Membership',
        payment: 'Account',
        welcome: 'Welcome',
        welcomeBack: 'Welcome Back',
      },
    },
    explore: {
      clubList: {
        miles: 'miles',
        sortBy: {
          favourites: 'Favorites',
        },
        favourites: 'Favorites',
        recentlyPlayed: 'Recently Played',
        mostVisited: 'Most Visited',
      },
    },
    pointsMatrix: {
      list: {
        headerDescription: 'Discover points tariffs at clubs',
        searchByPostcode: 'Search by ZIP Code',
        searchByClubName: 'Search by Club Name',
      },
    },
    userDetails: {
      postcode: 'Zip Code',
      townCity: 'City',
    },
    register: {
      firstName: 'First Name',
      surname: 'Last Name',
      validation: {
        surname: 'Last Name required',
      },
    },
    home: {
      renew: {
        benefit1: {
          body: 'Play golf at the best price.',
          title: 'Great value golf',
        },
        benefit2: {
          body: 'Use our app to make bookings on the go, when it suits you.',
          title: 'Book via our website or app',
        },
        benefit3: {
          body: 'Golf is better with friends, continue to bring along guests or other members.',
          title: 'Bring up to 3 guests',
        },
        benefit4: {
          body: 'Get ahead of the crowd and book in advance',
          title: 'Preferential booking window',
        },
        buttonHelp: 'Renewing now will add another year to your current renewal date.',
        buttonText: 'Renew now',
        title: '',
      },
      topUp: {
        flexi: {
          body: 'Additional Open Play Points can be spent on rounds of golf at any club in the PlayMoreGolf network, including your Home Club. They are valid for 12 months from purchase.',
          info: 'This package will not extend your renewal date.',
          subtitle: 'More points to play at home or away',
          title: 'Open Play  points',
        },
        home: {
          body: 'Additional Home Points can be spent on rounds of golf at your home clubs.',
          info: 'This package will not extend your renewal date.',
          subtitle: 'More points to play at home',
          title: 'Home points',
        },
        loading: 'Loading top-up packages',
      },
    },
    package: {
      startYourMembershipExplainer: 'Start your membership and receive great benefits',
    },
    virtus: {
      search: {
        heroTitle: 'Find Your Next Round',
        heroSubtitle: 'Instant confirmations at Virtus Golf, plus concierge-handled requests at our curated partner courses.',
        dateLabel: 'Date',
        earliestLabel: 'Earliest',
        latestLabel: 'Latest',
        playersLabel: 'Players',
        instantLegend: 'Instant booking — confirmed at click',
        requestLegend: 'Request booking — concierge coordinates with the course',
        instantSection: 'Instant Booking',
        instantSubtitle: 'Live tee sheet · Virtus Golf',
        instantCta: 'View Live Tee Sheet',
        requestSection: 'Partner Courses · Request Only',
        requestCountSuffix: 'curated partners',
        requestCardCta: 'Request →',
      },
      request: {
        stepOneLabel: 'Step 1 of 2',
        stepTwoLabel: 'Step 2 of 2',
        formTitle: 'Request a tee time',
        reviewTitle: 'Review & submit',
        datePlaceholder: 'Preferred date',
        windowLabel: 'Preferred time window',
        rankedHeading: 'Rank three preferred times',
        rankedSubheading: 'The club picks the first one that works.',
        rank1Label: '1st choice',
        rank2Label: '2nd choice',
        rank3Label: '3rd choice',
        flexHeading: 'Flexibility',
        flexAnyTime: 'Any time within the window is acceptable',
        flexAnyDay: 'Any day this week is acceptable (concierge may shift ±2 days)',
        notesLabel: 'Notes for the concierge',
        notesPlaceholder: 'Anything the course should know (guests, mobility, walking vs cart)?',
        partyLabel: 'Party size',
        continueCta: 'Continue to review',
        backToEdit: '← Edit request',
        submitCta: 'Submit request',
        submittingCta: 'Submitting request…',
        sessionExpired: 'Your request session has expired.',
        startNew: 'Start a new request',
        validationMissing: 'Please fill all three ranked choices.',
        validationDuplicate: 'Each ranked choice must be unique.',
        validationOutOfWindow: 'Choices must sit inside the preferred window (unless “any time in window” is checked).',
        whatNext: 'What happens next.',
        whatNextBody: "We'll send your ranked preferences to the course's tee sheet with a secure link. You'll be notified as soon as they select your preferred option.",
      },
      submitted: {
        title: 'Request sent',
        subtitle: 'Your ranked preferences are on their way to the course. Most partners respond within 2 hours.',
        requestIdLabel: 'Request ID',
        idNote: 'Keep this for your records — also available in My Requests.',
        emailPreviewShow: 'Show email preview',
        emailPreviewHide: 'Hide preview',
        whatWeSent: 'What we sent',
        emailSentBody: "A concierge email has been dispatched to {club} with your three ranked preferences. They'll click a secure link to confirm one of your options.",
        viewStatus: 'View request status',
        browseMore: 'Browse more courses',
      },
      myRequests: {
        title: 'My Requests',
        subtitle: 'Tee time requests handled by the Virtus concierge.',
        allFilter: 'All',
        emptyAll: 'No requests yet — start one from the search page.',
        emptyFiltered: 'No requests match this filter.',
        openDetail: 'View detail →',
      },
      detail: {
        backToList: '← Back to My Requests',
        courseLabel: 'Course',
        dateLabel: 'Date',
        windowLabel: 'Window',
        rankedLabel: 'Ranked preferences',
        flexLabel: 'Flexibility',
        partyLabel: 'Party size',
        notesLabel: 'Notes',
        timelineLabel: 'Timeline',
        acceptedHeading: 'Confirmed',
        acceptedBody: 'The course selected Option {rank}. Full details are in your calendar.',
        declinedHeading: 'Declined',
        declinedBody: 'The course could not accommodate this request. Try another partner or a different window.',
        nextAwaiting: "We've sent your preferences to the course. Most respond within 2 hours.",
        nextRequested: 'Hold on while we dispatch your preferences.',
        nextExpired: 'This request expired before the course responded. Start a new one if you still want to play.',
      },
      status: {
        Requested: 'Submitted',
        PendingClub: 'Awaiting Club',
        Accepted: 'Confirmed',
        Declined: 'Declined',
        Expired: 'Expired',
      },
      admin: {
        queueTitle: 'Concierge Queue',
        queueSubtitle: 'All tee time requests · updated live from the demo store',
        tableView: 'Table',
        kanbanView: 'Kanban',
        colId: 'Request ID',
        colMember: 'Member',
        colClub: 'Club',
        colDate: 'Date',
        colStatus: 'Status',
        colAge: 'Age',
        colActions: 'Actions',
        emptyFilter: 'No requests match this filter.',
        reviewCta: 'Review →',
        detailBack: '← Back to queue',
        rankedLabel: 'Ranked preferences',
        timelineLabel: 'Status timeline',
        communicationsLabel: 'Communication log',
        noCommunications: 'No outbound messages yet.',
        auditTrail: 'Admin audit trail',
        overrideHeading: 'Manual override',
        overrideSubtitle: 'Requires a justification. Recorded to the audit trail.',
        overrideTerminal: 'This request is already {status} — no overrides available.',
        actionLabel: 'Action',
        optionLabel: 'Option to confirm',
        justificationLabel: 'Justification',
        justificationPlaceholder: 'Why is manual action needed? e.g. Club rang to confirm Option 2 verbally.',
        justificationRequired: 'Justification is required.',
        applyingCta: 'Applying…',
        applyCta: 'Apply override',
        approveOption: 'Approve manually (pick option)',
        declineOption: 'Decline request',
        extendOption: 'Extend expiry by 24h',
        acceptanceLinks: 'Acceptance links',
        acceptanceLinksSubtitle: 'Open to test the club-side flow.',
        rulesTitle: 'Booking Rules',
        rulesSubtitle: 'Toggle how each slot is offered to members. Tee-sheet search honors these rules immediately.',
        windowHeading: 'Booking window',
        windowSubtitle: 'How many days ahead a Virtus member can request tee times.',
        matrixHeading: 'Slot availability matrix',
        matrixHelp: 'Click any cell to cycle Available → Request-only → N/A. Changes persist immediately.',
        savedFlash: '✓ Saved',
        resetDemo: 'Reset demo data',
        resetConfirm: 'Reset all demo requests, tokens, overrides and rules to seed state?',
        backToMember: '← Back to member view',
      },
      email: {
        subject: 'Virtus Member tee time request — {club}',
        greeting: 'Hello {club} team,',
        body: 'A Virtus Golf member has requested a tee time on {date}. Three ranked options are below — please select the first one that works, or decline.',
        expiryNote: 'This link expires in 24 hours.',
        signature: "Virtus Golf Concierge — we coordinate so you don't have to.",
      },
    },
  },
};

export default enUSMessages;
